import React from "react"

export const NotifyIcon = ({ height = 24, width = 24, fill = "var(--color-primary)", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#F9FBFB"
    />
    <path
      d="M24 33C28.4183 33 32 29.4183 32 25C32 20.5817 28.4183 17 24 17C19.5817 17 16 20.5817 16 25C16 29.4183 19.5817 33 24 33Z"
      stroke={fill}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M24 21V25L26 27" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M17 15L14 18" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M34 18L31 15" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.38 30.7L16 33" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M29.6406 30.67L32.0006 33" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)
